<template>
  <div class="bindingVip">
    <!-- Header -->
    <Header :headerTitle="$t('m.bindingVip.title')"></Header>
    <section>
      <b-input-group :prepend="$t('m.bindingVip.cardTitle')" class="mt-3">
        <b-form-input type="text" v-model="code" :placeholder="$t('m.bindingVip.placeholdeVipNo')"/>
      </b-input-group>
      <b-button @click="saveClick()" :disabled="code==null || code==''">{{$t('m.bindingVip.save')}}</b-button>
    </section>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { binDingVip } from "@/api/vip.js";
export default {
  name: "BindingVip",
  data() {
    return {
      code: "", //卡号
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      interval: null
    };
  },
  methods: {
    saveClick: function() {
      var openId = localStorage.getItem("openId");
      binDingVip({ openId: openId, cardNo: this.code }).then(
        response => {
          if (response.data.status == 200) {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = this.$t('m.bindingVip.binDingSuccess');
            this.tipType = "success";
            this.interval = setInterval(() => {
              this.$router.push("/vipInfo");
              if (this.interval != null) {
                clearInterval(this.interval);
              }
            }, 1200);
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    }
  }, //页面离开事件
  destroyed() {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
  }
};
</script>
<style scoped>
.bindingVip section {
  margin-top: 20px;
}
section .input-group {
  margin: 0 auto;
  padding: 0;
}
section .input-group-text {
  border-left: 0;
  background-color: #fff;
  height: 50px;
  line-height: 40px;
  border-radius: 0;
  border-color: #efefef;
  box-shadow: 1px 0px 1px #efefef;
}
section input {
  border-right: 0px;
  height: 50px;
  border-radius: 0;
  border-color: #efefef;
  box-shadow: 1px 0px 1px #efefef;
}
section button {
  margin: 0 auto;
  margin-top: 100px;
  line-height: 35px;
  width: 80%;
  display: block;
  background-color: #0061B1;
}
</style>


